import React from 'react';

const BusinessInNumbersCard = props => {
  const { title, description, color } = props;

  return (
    <div className="py-[8px] px-[32px] min-h-[110px] w-[250px] rounded-[5px] flex flex-col items-center shadow-[0px_0px_13.5px_0px_rgba(0,82,180,0.32)] gap-[8px]">
      <h3 className={`text-[36px] font-[600] leading-[44px] text-[${color}]`}>{title}</h3>
      <div className="flex-1 flex flex-col justify-center">
        <p className="text-[16px] font-[400] leading-[20px] text-center">{description}</p>
      </div>
    </div>
  );
};

export default BusinessInNumbersCard;
